// ─── Dashboard ────────────────────────────────────────────────────────────────

// Dynamic values only — labels, icons, colors stay in dashboard-kitchenOS.js
export const MOCK_STAT_VALUES = [
  { value: "42",  metaValue: "+12%", highlight: false },              // Active Orders
  { value: "8",   metaValue: "3",    highlight: true  },              // Low Stock Items
  { value: "94%", metaValue: "2m",   highlight: false },              // Prep Efficiency
  { value: "156", metaValue: "78%",  highlight: false, progress: 78 }, // Tasks Completed
];

export const MOCK_PREP_REQUESTS = [
  { id: 1, name: "Pizza Dough",       current: "15 units", target: "50 units",  urgency: "ASAP"          },
  { id: 2, name: "Tomato Sauce",      current: "2 Liters",  target: "10 Liters", urgency: "ASAP"          },
  { id: 3, name: "Chopped Onions",    current: "5 kg",      target: "12 kg",     urgency: "Within 2h"     },
  { id: 4, name: "Marinated Chicken", current: "10 kg",     target: "25 kg",     urgency: "Evening Shift"  },
  { id: 5, name: "Garlic Butter",     current: "1 kg",      target: "4 kg",      urgency: "Within 2h"     },
];

export const MOCK_INVENTORY_ALERTS = [
  { id: 1, name: "Fresh Basil",       percent: 12 },
  { id: 2, name: "Mozzarella Cheese", percent: 18 },
  { id: 3, name: "Olive Oil",         percent: 25 },
  { id: 4, name: "Packaging Boxes",   percent: 8  },
];

// ─── Shared ───────────────────────────────────────────────────────────────────

// Outlet list used by filter dropdowns across all pages
export const MOCK_LOCATION_OPTIONS = [
  { label: "Downtown Store", value: "Downtown Store" },
  { label: "Airport Kiosk",  value: "Airport Kiosk"  },
  { label: "Central Bakery", value: "Central Bakery" },
  { label: "Uptown Cafe",    value: "Uptown Cafe"    },
  { label: "Westside Diner", value: "Westside Diner" },
];

// ─── Fulfillment ──────────────────────────────────────────────────────────────

export const MOCK_DISPATCH_QUEUE = [
  { id: "dsp-001", destination: "Downtown Store", totalUnits: 145, totalSKUs: 12, dispatchMode: "Direct Sale",  status: "Ready",   financialImpact: "$450.00"       },
  { id: "dsp-002", destination: "Airport Kiosk",  totalUnits: 45,  totalSKUs: 5,  dispatchMode: "Stock Transfer", status: "Ready",  financialImpact: "N/A"           },
  { id: "dsp-003", destination: "Central Bakery", totalUnits: 80,  totalSKUs: 8,  dispatchMode: "Consignment",  status: "Pending", financialImpact: "Pending Recon" },
  { id: "dsp-004", destination: "Uptown Cafe",    totalUnits: 210, totalSKUs: 15, dispatchMode: "Periodic SO",  status: "Ready",   financialImpact: "Accrued"       },
  { id: "dsp-005", destination: "Westside Diner", totalUnits: 25,  totalSKUs: 3,  dispatchMode: "PO-Linked",    status: "Pending", financialImpact: "$120.00"       },
];

export const MOCK_STORE_PICKUPS = [
  { id: "pck-001", sourceStore: "Downtown Store", totalUnits: 50, totalSKUs: 5, returnType: "Empty Crates",    status: "Ready",   readyTime: "11:00 AM" },
  { id: "pck-002", sourceStore: "Airport Kiosk",  totalUnits: 15, totalSKUs: 2, returnType: "Expired Stock",   status: "Ready",   readyTime: "01:30 PM" },
  { id: "pck-003", sourceStore: "Central Bakery", totalUnits: 25, totalSKUs: 4, returnType: "Equipment Repair", status: "Pending", readyTime: "03:00 PM" },
];

export const MOCK_RECON_RECORDS = [
  { id: "recon-001", outlet: "Central Bakery", date: "Today", sentQty: 120, returnedQty: 15, impliedSales: 105, variance: "Matched",   varianceType: "matched" },
  { id: "recon-002", outlet: "Downtown Store", date: "Today", sentQty: 80,  returnedQty: 5,  impliedSales: 70,  variance: "-5 units",  varianceDetail: "Wastage (Kitchen)", varianceType: "warning" },
];

// ─── History ──────────────────────────────────────────────────────────────────

export const MOCK_HISTORY_RECORDS = [
  { id: "PR-8492", outlet: "Downtown Store", itemCount: 4, totalQty: 125, status: "Approved", requestedDate: "Apr 01, 08:30 AM", lastUpdated: "Apr 01, 09:15 AM" },
  { id: "PR-8491", outlet: "Airport Kiosk",  itemCount: 2, totalQty: 60,  status: "Partial",  requestedDate: "Apr 01, 07:45 AM", lastUpdated: "Apr 01, 08:20 AM" },
  { id: "PR-8490", outlet: "Central Bakery", itemCount: 1, totalQty: 200, status: "Rejected", requestedDate: "Mar 31, 06:00 PM", lastUpdated: "Mar 31, 06:45 PM" },
];

// ─── Inventory Compute ────────────────────────────────────────────────────────

export const MOCK_INVENTORY_SUMMARY = { itemsToOrder: 5, vendorsInvolved: 4, estimatedCost: 1041.0 };

export const MOCK_INITIAL_INGREDIENTS = [
  { id: 1, name: "Potato",            vendor: "Fresh Farms",   required: 50,  inStock: 25, unit: "kg", unitCost: 2.5  },
  { id: 2, name: "Flour (Maida)",     vendor: "Grain Millers", required: 100, inStock: 20, unit: "kg", unitCost: 1.2  },
  { id: 3, name: "Chicken Breast",    vendor: "Poultry Plus",  required: 80,  inStock: 15, unit: "kg", unitCost: 8.0  },
  { id: 4, name: "Tomato Puree",      vendor: "Fresh Farms",   required: 40,  inStock: 5,  unit: "L",  unitCost: 3.5  },
  { id: 5, name: "Mozzarella Cheese", vendor: "Dairy Direct",  required: 30,  inStock: 8,  unit: "kg", unitCost: 12.0 },
];

// ─── Prep Requests ────────────────────────────────────────────────────────────

// Outlet list for the New Request form dropdown
export const MOCK_OUTLET_OPTIONS = [
  { label: "Downtown Store", value: "downtown" },
  { label: "Airport Kiosk",  value: "airport"  },
  { label: "Central Bakery", value: "bakery"   },
];

export const MOCK_PREP_SLOTS = [
  {
    slot: "Morning Prep Slot",
    items: [
      { name: "Samosas",      prepTime: "05:00 AM", targetTime: "08:00 AM", priority: "High",   qty: 65,  unit: "units" },
      { name: "Garlic Butter", prepTime: "06:00 AM", targetTime: "09:00 AM", priority: "Medium", qty: 15,  unit: "L"     },
    ],
  },
  {
    slot: "Lunch Prep Slot",
    items: [
      { name: "Pizza Dough",        prepTime: "10:00 AM", targetTime: "02:00 PM", priority: "High", qty: 120, unit: "kg" },
      { name: "Tomato Sauce Master", prepTime: "08:00 AM", targetTime: "11:00 AM", priority: "Low",  qty: 80,  unit: "L"  },
    ],
  },
  {
    slot: "Dinner Prep Slot",
    items: [
      { name: "Marinated Chicken Tikka", prepTime: "01:00 PM", targetTime: "05:00 PM", priority: "Medium", qty: 40, unit: "kg" },
    ],
  },
];

export const MOCK_PREP_STORES = [
  {
    store: "Downtown Store",
    items: [
      { name: "Samosas",            prepSlot: "Morning", targetTime: "08:00 AM", priority: "High",   qty: 20, unit: "units" },
      { name: "Pizza Dough",        prepSlot: "Lunch",   targetTime: "02:00 PM", priority: "High",   qty: 40, unit: "kg"    },
      { name: "Tomato Sauce Master", prepSlot: "Lunch",  targetTime: "11:00 AM", priority: "Low",    qty: 15, unit: "L"     },
    ],
  },
  {
    store: "Airport Kiosk",
    items: [
      { name: "Samosas",      prepSlot: "Morning", targetTime: "08:00 AM", priority: "High",   qty: 15, unit: "units" },
      { name: "Garlic Butter", prepSlot: "Morning", targetTime: "09:00 AM", priority: "Medium", qty: 5,  unit: "L"     },
    ],
  },
  {
    store: "Central Bakery",
    items: [
      { name: "Pizza Dough",            prepSlot: "Lunch",  targetTime: "02:00 PM", priority: "High",   qty: 80, unit: "kg" },
      { name: "Marinated Chicken Tikka", prepSlot: "Dinner", targetTime: "05:00 PM", priority: "Medium", qty: 25, unit: "kg" },
    ],
  },
];

export const MOCK_PREP_ITEMS = [
  { name: "Samosas",               totalNeeded: 65,  unit: "units", outlets: 3, prepStart: "05:00 AM", targetTime: "08:00 AM", priority: "High",   slot: "Morning" },
  { name: "Pizza Dough",           totalNeeded: 120, unit: "kg",    outlets: 5, prepStart: "10:00 AM", targetTime: "02:00 PM", priority: "High",   slot: "Lunch"   },
  { name: "Garlic Butter",         totalNeeded: 15,  unit: "L",     outlets: 2, prepStart: "06:00 AM", targetTime: "09:00 AM", priority: "Medium", slot: "Morning" },
  { name: "Marinated Chicken Tikka", totalNeeded: 40, unit: "kg",   outlets: 4, prepStart: "01:00 PM", targetTime: "05:00 PM", priority: "Medium", slot: "Dinner"  },
  { name: "Tomato Sauce Master",   totalNeeded: 80,  unit: "L",     outlets: 6, prepStart: "08:00 AM", targetTime: "11:00 AM", priority: "Low",    slot: "Lunch"   },
];

// ─── Reports & Analysis ───────────────────────────────────────────────────────

export const MOCK_PO_FILL_RATES = [
  { id: "KOS-PO-2026-089", outlet: "Downtown Store", requestedQty: 450, dispatchedQty: 450, fillRate: 100,  date: "Oct 24" },
  { id: "KOS-PO-2026-088", outlet: "Airport Kiosk",  requestedQty: 120, dispatchedQty: 110, fillRate: 91.6, date: "Oct 24" },
  { id: "KOS-PO-2026-087", outlet: "Central Bakery", requestedQty: 800, dispatchedQty: 600, fillRate: 75,   date: "Oct 23" },
  { id: "KOS-PO-2026-086", outlet: "Uptown Cafe",    requestedQty: 320, dispatchedQty: 320, fillRate: 100,  date: "Oct 23" },
];

export const MOCK_PRODUCTION_BATCHES = [
  { id: "B-8839", item: "Pizza Dough",  inputKg: 100, outputKg: 95,   yieldPct: 95,   qcStatus: "Passed"  },
  { id: "B-8840", item: "Tomato Sauce", inputKg: 50,  outputKg: 42,   yieldPct: 84,   qcStatus: "Warning" },
  { id: "B-8841", item: "Garlic Butter", inputKg: 20, outputKg: 19.5, yieldPct: 97.5, qcStatus: "Passed"  },
];

export const MOCK_OUTLET_METRICS = [
  { outlet: "Downtown Store", posPlaced: 24, itemsRequested: 3400, fillRate: 100,  returnsRejects: 2  },
  { outlet: "Uptown Cafe",    posPlaced: 18, itemsRequested: 2100, fillRate: 96.5, returnsRejects: 5  },
  { outlet: "Central Bakery", posPlaced: 30, itemsRequested: 5500, fillRate: 92,   returnsRejects: 15 },
  { outlet: "Airport Kiosk",  posPlaced: 12, itemsRequested: 1200, fillRate: 75,   returnsRejects: 24 },
];

export const MOCK_WASTAGE_LOG = [
  { item: "Fresh Basil",    category: "Vegetables", qtyWasted: "15 kg", reason: "Spoilage",              costImpact: "$340.00" },
  { item: "Pizza Dough",    category: "Prepared",   qtyWasted: "20 kg", reason: "Over-proofed",          costImpact: "$120.00" },
  { item: "Chicken Breast", category: "Proteins",   qtyWasted: "8 kg",  reason: "Dropped/Contaminated",  costImpact: "$64.00"  },
  { item: "Tomato Sauce",   category: "Sauces",     qtyWasted: "12 L",  reason: "Burnt in prep",         costImpact: "$45.00"  },
];

export const MOCK_INVOICES = [
  { id: "INV-2026-104", outlet: "Downtown Store", period: "Oct 15 - Oct 21", amount: "$8,450.00",  status: "Settled"     },
  { id: "INV-2026-105", outlet: "Uptown Cafe",    period: "Oct 15 - Oct 21", amount: "$5,200.00",  status: "Outstanding" },
  { id: "INV-2026-106", outlet: "Central Bakery", period: "Oct 15 - Oct 21", amount: "$14,800.00", status: "Settled"     },
  { id: "INV-2026-107", outlet: "Airport Kiosk",  period: "Oct 15 - Oct 21", amount: "$3,100.00",  status: "Overdue"     },
];

// Pure numeric/factual values only — static label text lives in the component JSX
export const MOCK_REPORT_SUMMARY_STATS = {
  poFillRates: {
    avgFillRate: "92.4%",    avgFillRateDelta: "+1.2%",   // "this week" → static
    totalPosFulfilled: "148", outletCount: 12,              // "Across X outlets" → static
    lowFillRateAlerts: "3",                                 // "POs below 80% threshold" → static
  },
  production: {
    avgYieldRate: "94.2%",   avgYieldRateDelta: "+2.1%",   // "vs target" → static
    totalOutputKg: "1,245.5", activeBatches: 45,            // "Across X active batches" → static
    productionWasteKg: "72.4", wastePercentage: "5.8%",    // "of total raw materials" → static
  },
  outletPerf: {
    topOutlet: "Downtown Store", topOutletFillRate: "100%", topOutletRejections: 0,
    needsAttention: "Airport Kiosk", needsAttentionFillRate: "75%", needsAttentionMissed: 3,
    avgOrderValue: "$1,240",                                // "Per outlet/day" → static
  },
  wastageCost: {
    totalWasteCost: "$1,450.20",                            // "This Week" → static
    topWastedItem: "Fresh Basil", topWastedReason: "Spoilage", topWastedQty: "15kg", topWastedCost: "$340",
    wastePctOfCost: "3.2%", wastePctDelta: "-0.8%",        // "vs last week (Improved)" → static
  },
  interOrgBilling: {
    totalBilledMTD: "$45,280", billingPeriod: "October 2026",
    outstandingInvoices: "$12,450", outstandingInvoiceCount: 8,  // "Across X invoices" → static
    settled: "$32,830", collectionRate: "72%",             // "Collection Rate" → static
  },
};

// ─── Settings ─────────────────────────────────────────────────────────────────

export const MOCK_INITIAL_SLOTS = [
  { id: 1, title: "Morning Prep",    startTime: "06:00", endTime: "11:00", category: "Dough & Sauces"    },
  { id: 2, title: "Lunch Rush Prep", startTime: "11:00", endTime: "14:00", category: "Salads & Proteins" },
  { id: 3, title: "Dinner Prep",     startTime: "15:00", endTime: "18:00", category: "All Categories"    },
];

export const MOCK_DEFAULT_SETTINGS = {
  dispatchMode:    { label: "Direct Sale (Auto-SO)",   value: "direct-sale" },
  billingCycle:    { label: "Weekly Consolidation",    value: "weekly"      },
  lookbackWindow:  { label: "4 Weeks (Standard)",      value: "4w"          },
  twoLevelApproval: true,
  wastageCost:     { label: "Kitchen Org (Default)",   value: "kitchen"     },
  qcCost:          { label: "Kitchen Org (Default)",   value: "kitchen"     },
  downtownTier:    { label: "Tier 1 (+10% Margin)",    value: "tier1"       },
  airportTier:     { label: "Tier 2 (+15% Margin)",    value: "tier2"       },
};
